/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */
/* eslint-disable no-undefined */

import NetworkType from '../network/network-type';

import template from './generator-form.html';

export default {
  name: 'GeneratorForm',
  template,
  data () {
    return {
      connections: [
        {
          mac: '',
          number: 1,
          selected: NetworkType.Ethernet
        },
        {
          mac: '',
          number: 2,
          selected: NetworkType.Wifi
        }
      ],
      strategy: 'snmac',
      fingerprint: '',
      error: null,
      options: [
        {text: 'Ethernet', value: NetworkType.Ethernet},
        {text: 'Wi-Fi', value: NetworkType.Wifi}
      ],
      strategies: [
        {text: 'Default', value: 'snmac'},
        {text: 'SerialNumber', value: 'sn'},
        {text: 'MAC', value: 'mac'},
        {text: 'LAN MAC', value: 'lanmac'},
        {text: 'WLAN MAC', value: 'wlanmac'}
      ],
      serialNumber: '',
      multiInstanceId: ''
    };
  },
  methods: {
    addConnection () {
      const {connections} = this;
      connections.push({
        mac: '',
        number: connections.length + 1,
        selected: NetworkType.Ethernet
      });
    },
    onSubmit (event) {
      event.preventDefault();
      this.error = undefined;
      const {fingerprintManager, firmwareManager, networkConnectionFactory,
        networkManager} = this.$root;
      firmwareManager.setSerialNumber(this.serialNumber);
      // eslint-disable-next-line no-ternary
      firmwareManager.setMultiInstanceId(this.multiInstanceId === '' ? null : this.multiInstanceId);
      networkManager.setAllConnections(
        this.connections.filter((connection) => connection.mac)
        .map((connection) => (
          networkConnectionFactory.create(connection.mac, connection.selected)
        ))
      );
      fingerprintManager.setFingerprintStrategy(this.strategy);
      return (
        fingerprintManager.generate()
        .then((fingerprint) => {
          this.fingerprint = fingerprint;
        })
        .catch((err) => {
          this.error = err;
        })
      );
    }
  }
};
